<template>
    <div class="button-set business-tax-summary-page">
        <div class="upper">
            <div></div>
            <div>
                <el-button size="small" @click="onSelectAll"> 全選此頁 {{ data.length }} 筆 </el-button>
                <el-tooltip
                    v-if="isDeclareBtnShow"
                    class="item"
                    effect="dark"
                    :content="tooltipContent"
                    :manual="!(selectedItems.length && (isDeclareBtnDisabled || isDeclareCrossPeriodInvoice))"
                    placement="top"
                >
                    <el-button type="primary" size="small" v-loading="isLoading" :disabled="isDeclareBtnDisabled || isDeclareCrossPeriodInvoice" @click="onSetDeclarePeriod">
                        標示申報期別 {{ selectedItems.length }} 筆
                    </el-button>
                </el-tooltip>
                <el-button v-if="!isDeclareBtnShow && isShowSelectActions" type="primary" size="small" v-loading="isLoading" :disabled="isDeclareBtnDisabled" @click="onMarkUndeclared">
                    恢復為未申報 {{ selectedItems.length }} 筆
                </el-button>
                <el-button
                    v-if="isBatchMarkNonDeclare && isShowSelectActions"
                    type="primary"
                    size="small"
                    v-loading="isLoading"
                    :disabled="isBatchMarkNonDeclareDisabled"
                    @click="onMarkNonDeclareStatus"
                >
                    批次標示不申報扣抵 {{ selectedItems.length }} 筆
                </el-button>
                <el-button v-if="isAutoCodeShow && isShowSelectActions" size="small" v-loading="isLoading" @click="onAutoChangeCode">自動格式代號</el-button>
                <el-button size="small" v-loading="isLoading" @click="onExportExcel"> 匯出Excel </el-button>
            </div>
        </div>
        <div class="right-area">
            <div class="query-block">
                <el-input v-model="foo" placeholder="發票號碼" size="small" @keydown.enter.native="onSearch" />
                <el-input v-model="bsn" :placeholder="isIncome ? '買方統編' : '賣方統編'" size="small" @keydown.enter.native="onSearch" />
                <money-input v-model="amt" placeholder="含稅金額" size="small" is-search @keydown.enter.native="onSearch" />
            </div>
            <el-button v-if="isMediaFileExportShow" size="small" type="highlight" v-loading="isLoading" @click="onExportMediaFile(true)"> 匯出媒體檔 </el-button>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import {
    mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';
import ExcelMixins from '@/components/dashboard/Accounting/BusinessTax/ExcelMixins';
import invoiceSerialNumber from '@/assets/commonData/invoiceSerialNumber';

export default {
    mixins: [ExcelMixins],
    data() {
        return {
            isLoading: false,

            foo: null,
            bsn: null,
            amt: null,
        };
    },
    computed: {
        ...mapState({
            // isLoading: (state) => state.businessTax.isLoading,
            periodList: (state) => state.businessTax.periodList,
            selectedItems: (state) => state.businessTax.selectedItems,
            selectedInvoiceItems: (state) => state.businessTax.selectedInvoiceItems,
            selectedPaymentItems: (state) => state.businessTax.selectedPaymentItems,

            declaredInvoiceItems: (state) => state.businessTax.declaredInvoiceItems,
            declaredPaymentItems: (state) => state.businessTax.declaredPaymentItems,

            data: (state) => state.businessTax.datas,
            queryParams: (state) => state.businessTax.queryParams,
            isIncome: (state) => state.businessTax.queryParams.QueryType === 1,
            currentTableVueComponent: (state) => state.businessTax.currentTableVueComponent,
        }),
        ...mapGetters({
            companyInfo: 'menu/companyInfo',
        }),
        isMediaFileExportShow() {
            return this.queryParams.SearchType === 2;
        },

        isDeclareBtnShow() {
            return Number(this.$route.query.TaxDeclareStatus) === 1;
        },
        isDeclareBtnDisabled() {
            const INVALID_DATA_LIST = this.selectedItems.filter((o) => !o.code || o.code === '0');
            return !this.selectedItems.length || !!INVALID_DATA_LIST.length;
        },
        isBatchMarkNonDeclare() {
            return !this.isIncome && Number(this.$route.query.TaxDeclareStatus) === 1;
        },
        isBatchMarkNonDeclareDisabled() {
            return !this.selectedPaymentItems.length;
        },
        isAutoCodeShow() {
            return this.selectedItems.length;
        },
        isDeclareCrossPeriodInvoice() {
            const foundPeriodList = [];
            this.selectedInvoiceItems.forEach((item) => {
                foundPeriodList.push(this.periodList.find((o) => o.months.includes(moment(item.foO_DAT).month() + 1)).value);
            });
            return _.uniq(foundPeriodList).length > 1;
        },
        isShowSelectActions() {
            return !(this.queryParams.TaxDeclareStatus === 4 || (this.queryParams.QueryType !== 2 && this.queryParams.TaxDeclareStatus === 3));
        },

        tooltipContent() {
            if (this.isDeclareBtnDisabled) return '申報資料不完整';
            if (this.isDeclareCrossPeriodInvoice) return '選取之銷項項目包含非相同申報期別選項';
            return '--';
        },
    },
    methods: {
        ...mapMutations({
            updateQuery: 'businessTax/updateQuery',
            onClearSelection: 'businessTax/onClearSelection',
            setDeclarePeriod: 'businessTax/setDeclarePeriod',
        }),
        ...mapActions({
            updateData: 'businessTax/updateData',
            updateDeclaredData: 'businessTax/updateDeclaredData',
        }),
        onSelectAll() {
            this.currentTableVueComponent.$refs.table.toggleAllSelection();
        },
        onSetDeclarePeriod() {
            this.$emit('onMarkDeclared');
        },
        async onMarkNonDeclareStatus() {
            try {
                const TCIN_LIST = _.chain(this.selectedPaymentItems)
                    .filter((o) => o.taxCredited)
                    .map((o) => ({ sno: o.sno, declareStatus: 2 }))
                    .value();
                const NON_TCIN_LIST = _.chain(this.selectedPaymentItems)
                    .filter((o) => o.payoo)
                    .map((o) => ({ sno: o.sno, declareStatus: 2 }))
                    .value();

                const errorList = [];
                if (TCIN_LIST.length) {
                    await this.$api({
                        url: 'AccountingSummaryPage/UpdatePaymentInvoiceDeclareStatus',
                        data: { payments: TCIN_LIST },
                        method: 'POST',
                    });
                }
                if (NON_TCIN_LIST.length) {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/UpdatePayment401DeclareStatus',
                        data: { payments: NON_TCIN_LIST },
                        method: 'POST',
                    });
                    if (resp.data?.fail) errorList.push(...resp.data.fail);
                }

                if (errorList.length) {
                    await this.$msgbox({
                        title: '',
                        message: `以下來源請款單已被退件或未審核，${errorList.length} 筆項目無法改變申報狀態：${errorList.join(', ')} `,
                        confirmButtonText: '我瞭解了',
                        closeOnClickModal: false,
                        showClose: false,
                    });
                    return;
                }
                this.$message({
                    showClose: true,
                    message: `已將 ${TCIN_LIST.length + NON_TCIN_LIST.length} 筆項目列入不申報扣抵`,
                    type: 'success',
                });

                this.updateData();
                this.onClearSelection();
            } catch (e) {
                console.log(e);
            }
        },
        async onMarkUndeclared() {
            try {
                // await this.$confirm(
                //     `確定要將 ${this.selectedItems.length} 筆資料移至為未申報嗎？`,
                //     {
                //         confirmButtonText: '確定',
                //         cancelButtonText: '取消',
                //     },
                // );

                const INVOICE_LIST = _.chain(this.selectedItems)
                    .filter((o) => o.ioo)
                    .map((o) => ({
                        sno: o.sno,
                        declareStatus: false,
                        updateType: o.typ > 0 ? 1 : 2,
                    }))
                    .value();

                const TRAN_INVOICE_LIST = _.chain(this.selectedItems)
                    .filter((o) => o.isTranInovice)
                    .map((o) => ({
                        sno: o.sno,
                        declareStatus: false,
                        updateType: o.typ > 0 ? 1 : 2,
                    }))
                    .value();

                const TCIN_LIST = _.chain(this.selectedItems)
                    .filter((o) => o.taxCredited)
                    .map((o) => ({
                        sno: o.sno,
                        declareStatus: 0,
                    }))
                    .value();
                const NON_TCIN_LIST = _.chain(this.selectedItems)
                    .filter((o) => o.payoo)
                    .map((o) => ({
                        sno: o.sno,
                        declareStatus: 0,
                    }))
                    .value();

                const errorList = [];
                if (INVOICE_LIST.length) {
                    await this.$api({
                        url: 'AccountingSummaryPage/UpdateInvoice401DeclareStatus',
                        data: { invoices: INVOICE_LIST, invoiceType: 1 },
                        method: 'POST',
                    });
                }
                if (TRAN_INVOICE_LIST.length) {
                    await this.$api({
                        url: 'AccountingSummaryPage/UpdateInvoice401DeclareStatus',
                        data: { invoices: TRAN_INVOICE_LIST, invoiceType: 2 },
                        method: 'POST',
                    });
                }
                if (TCIN_LIST.length) {
                    await this.$api({
                        url: 'AccountingSummaryPage/UpdatePaymentInvoiceDeclareStatus',
                        data: { payments: TCIN_LIST },
                        method: 'POST',
                    });
                }
                if (NON_TCIN_LIST.length) {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/UpdatePayment401DeclareStatus',
                        data: { payments: NON_TCIN_LIST },
                        method: 'POST',
                    });
                    if (resp.data?.fail) errorList.push(...resp.data.fail);
                }

                if (errorList.length) {
                    await this.$msgbox({
                        title: '',
                        message: `以下來源請款單已被退件或未審核，${errorList.length} 筆項目無法改變申報狀態：${errorList.join(', ')} `,
                        confirmButtonText: '我瞭解了',
                        closeOnClickModal: false,
                        showClose: false,
                    });
                    return;
                }
                this.$message({
                    showClose: true,
                    message: `已將 ${INVOICE_LIST.length + TCIN_LIST.length + NON_TCIN_LIST.length} 筆項目恢復為未申報`,
                    type: 'success',
                });

                this.updateData();
                this.onClearSelection();
            } catch (e) {
                console.log(e);
            }
        },
        async onExportMediaFile(protection) {
            this.isLoading = true;
            try {
                const target = [...this.declaredInvoiceItems, ...this.declaredPaymentItems];
                console.log(target);
                const isNotExportable = target.find((o) => !o.code || o.code === '0');
                if (protection && isNotExportable) {
                    this.$message({
                        showClose: true,
                        message: '尚有項目未設定格式代號',
                        type: 'error',
                    });
                    return;
                }
                const formatedTxt = this.getUploadFormat(target);
                this.onDownload(`${this.companyInfo.bsn || '無公司統編'}.txt`, formatedTxt);
            } finally {
                this.isLoading = false;
            }
        },
        getUploadFormat(items) {
            const row = [];
            items.forEach((item, i) => {
                const IS_INCOME = !!item.ioo || !!item.tioo;
                const IS_FILE_TYP_11 = !IS_INCOME && item.filE_TYP === 11;

                const CODE = item.code;
                const TAX_STATUS = this.getPaddingString(this.companyInfo.taX_BOO, 9);
                const SERIAL = this.getPaddingString(i + 1, 7);
                const DATE = this.getROCDateFormat(IS_INCOME && item.typ < 0 ? item.orI_FOO_DAT : item.foO_DAT);
                let BUYER_NUM = this.getPaddingString(IS_INCOME ? item.bsn || '        ' : this.companyInfo.bsn, 8);
                // eslint-disable-next-line eqeqeq
                const IS_TYPE_B = item.code == 22 || item.code == 32 || BUYER_NUM === '        ';
                const SELLER_NUM = this.getPaddingString(IS_INCOME ? this.companyInfo.bsn : item.bsn, 8);
                let INVOICE_NUM = item.foo;
                let TAXATION = IS_INCOME ? item.tax : 1;

                let TAX_AMT = this.getPaddingString(this.getUploadFormatTaxAmount(item), 10);
                const NON_TAX_AMT = item.amt - this.getUploadFormatTaxAmount(item);
                let BILL_AMT = this.getPaddingString(NON_TAX_AMT, 12);
                const DEDUCT_CODE = IS_INCOME ? ' ' : 1;

                // 作廢
                if (item.foO_CNL) {
                    TAXATION = 'F';
                    BUYER_NUM = '        ';
                    BILL_AMT = this.getPaddingString(0, 12);
                    TAX_AMT = this.getPaddingString(0, 10);
                }

                // 車票單據號碼
                if (IS_FILE_TYP_11) INVOICE_NUM = this.getReceiptFormatFoo(item.foo);

                // 二聯式或發票銷售額需填寫含稅金額
                if (IS_TYPE_B) {
                    BILL_AMT = this.getPaddingString(item.amt, 12);
                    TAX_AMT = this.getPaddingString(0, 10);
                }

                row.push(
                    // eslint-disable-next-line max-len
                    `${CODE}${TAX_STATUS}${SERIAL}${DATE}${BUYER_NUM}${SELLER_NUM}${INVOICE_NUM}${BILL_AMT}${TAXATION}${TAX_AMT}${DEDUCT_CODE}`,
                );
            });

            return row.join('\n');
        },
        getUploadFormatTaxAmount(item) {
            return item.typ === undefined ? item.tax : item.amT_TAX;
        },
        onDownload(filename, text) {
            const element = document.createElement('a');
            element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`);
            element.setAttribute('download', filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        },

        getPaddingString(num, paddingLength) {
            return `${num}`.padStart(paddingLength, '0');
        },
        getROCDateFormat(timestamp) {
            const TIME = moment(timestamp);
            return `${TIME.year() - 1911}${TIME.format('MM')}`;
        },
        getReceiptFormatFoo(foo) {
            const FOO = foo.replaceAll('-', '');
            if (FOO.length < 10) return this.getPaddingString(foo, 10);
            return FOO.substring(FOO.length - 10, FOO.length);
        },

        onSearch() {
            this.updateQuery({
                Foo: this.foo ? _.toUpper(this.foo) : null,
                Bsn: this.bsn,
                Amt: this.amt,
            });
            this.updateData();
        },
        async onAutoChangeCode() {
            const target = this.selectedItems;

            const code401s = [];
            target.forEach((item) => {
                const validateCode = this.getValidateCode(item);
                if (validateCode) {
                    code401s.push({
                        sno: item.sno,
                        code: Number(validateCode),
                        taxCredited: item.taxCredited,
                        isTranInovice: item.isTranInovice,
                    });
                }
            });

            const TCIN_LIST = _.filter(code401s, ['taxCredited', true]);
            const NON_TCIN_LIST = _.filter(code401s, (o) => !o.taxCredited && !o.isTranInovice);
            const TRAN_INVOICE_LIST = _.filter(code401s, (o) => o.isTranInovice);

            try {
                await this.$confirm(`確定自動取得 ${target.length} 筆資料的格式代號？`, {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });
                if (TCIN_LIST.length) {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/UpdatePayInvoice401Code',
                        data: {
                            updateType: this.isIncome ? 1 : 2,
                            code401s,
                        },
                        method: 'POST',
                    });
                    console.log('UpdateTCIN401Code', resp);
                }

                if (NON_TCIN_LIST.length) {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/Update401Code',
                        data: {
                            updateType: this.isIncome ? 1 : 2,
                            code401s,
                        },
                        method: 'POST',
                    });
                    console.log('Update401Code', resp);
                }

                if (TRAN_INVOICE_LIST.length) {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/Update401Code',
                        data: {
                            updateType: 5,
                            code401s,
                        },
                        method: 'POST',
                    });
                    console.log('Tran Update401Code', resp);
                }

                // 檢查有更新的資料，並更新LocalStorage
                const CHANGED_SNO = [];
                target.forEach((item) => {
                    const FOUND = _.find(code401s, (o) => o.sno === item.sno && o.code !== item.code);
                    if (FOUND) CHANGED_SNO.push(FOUND);
                });

                CHANGED_SNO.forEach((item) => {
                    const LOCAL_DATA_NAME = this.queryParams.QueryType === 1 ? '401-selected-invoice' : '401-selected-payment';
                    const LOCAL_DATA = JSON.parse(window.localStorage.getItem(LOCAL_DATA_NAME)) || [];
                    const FOUND_INDEX = _.findIndex(LOCAL_DATA, ['sno', item.sno]);

                    if (FOUND_INDEX >= 0) {
                        const dataChanged = LOCAL_DATA[FOUND_INDEX];
                        dataChanged.code = item.code;
                        window.localStorage.setItem(LOCAL_DATA_NAME, JSON.stringify(LOCAL_DATA));
                    }
                });

                this.$message({
                    showClose: true,
                    message: `已更新 ${code401s.length} 筆格式代號`,
                    type: 'success',
                });
                this.updateData();
            } catch (e) {
                console.log(e);
            }
        },
        getValidateCode(item) {
            if (item.typ < 0) return undefined;
            if (item.filE_TYP === 11) return 22;

            const isIncome = item.typ !== undefined;
            const fooMonth = moment(item.foO_DAT).month() + 1;
            const fooYear = moment(item.foO_DAT).year();
            const fooKey = `${item.foo[0]}${item.foo[1]}`;
            const TYPE = _.chain(invoiceSerialNumber)
                .filter(['year', fooYear])
                .find((o) => o.month.includes(fooMonth))
                .get('datas')
                .find((o) => o.serialNumbers.includes(fooKey))
                .get('name')
                .value();

            const isCashierTripleInvoice = item.filE_TYP === 10;
            const TYPE_CODE = { A: 1, B: 2, D: 5 };
            if (TYPE) {
                return `${isIncome ? 3 : 2}${isCashierTripleInvoice ? 5 : TYPE_CODE[TYPE]}`;
            }
            return undefined;
        },
    },
};
</script>

<style lang="scss" scoped>
.business-tax-summary-page.button-set {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    width: 100%;

    .upper {
        display: flex;
    }
    .right-area {
        display: flex;
    }
    .query-block {
        display: flex;
        flex: 1;
        justify-content: space-between;
        padding: 0 20px;

        > .el-input {
            width: 130px;
            margin-right: 10px;
            &:last-child {
                margin-right: 0;
            }
        }
    }
}
</style>
